import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    /**
     * Navigates to a specific path while preserving existing query parameters
     * and adding or overriding with additional parameters.
     * @param path The target navigation path
     * @param additionalParams Query parameters to include or override
     */
    private navigateWithParams(path: string | string[], additionalParams: any = {}) {
        const currentParams = this.route.snapshot.queryParams;
        this.router.navigate(Array.isArray(path) ? path : [path], {
            queryParams: {
                ...currentParams, // Preserve existing parameters
                ...additionalParams, // Add or override with additional parameters
            },
        });
    }

    navigateToReassignment() {
        this.navigateWithParams(['home', 'reassignment']);
    }

    navigateToReassignmentBefore() {
        this.navigateWithParams(['home', 'reassignment', 'before']);
    }

    navigateToReassignmentAfter() {
        this.navigateWithParams(['home', 'reassignment', 'after']);
    }

    navigateToReassignmentTracker() {
        this.navigateWithParams(['home', 'reassignment', 'tracker']);
    }

    navigateToInbox() {
        this.navigateWithParams(['home', 'cases']);
    }

    navigateToEnquiry() {
        this.navigateWithParams(['home', 'enquiry']);
    }
}
